module.exports = __webpack_public_path__ + "img/icon_profile_edit.820d74ed.svg";